var _g, _g2, _g3, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _g4, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOldkey(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_715_14781)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.11719 26.455L11.1641 21.4081L14.3752 24.6193C14.8567 25.1007 14.8796 25.874 14.4274 26.3831C14.153 26.6921 13.7469 26.8504 13.3358 26.8086L12.2551 26.699C11.9894 26.6721 11.7261 26.7689 11.5411 26.9615C11.3697 27.1401 11.2827 27.3834 11.3019 27.6302L11.3853 28.7019C11.4124 29.0503 11.288 29.3935 11.044 29.6437C10.5717 30.1278 9.79486 30.1326 9.31663 29.6544L6.11719 26.455Z",
    fill: "url(#paint0_linear_715_14781)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_715_14781)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.3969 12.1719L19.8031 15.5781L6.86562 28.5156C5.92501 29.4562 4.39998 29.4562 3.45936 28.5156C2.51875 27.575 2.51875 26.05 3.45936 25.1094L16.3969 12.1719Z",
    fill: "url(#paint1_linear_715_14781)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_i_715_14781)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.8809 18C26.2819 18 29.8496 14.4323 29.8496 10.0312C29.8496 5.63023 26.2819 2.0625 21.8809 2.0625C17.4799 2.0625 13.9121 5.63023 13.9121 10.0312C13.9121 14.4323 17.4799 18 21.8809 18ZM21.8809 14C24.0728 14 25.8496 12.2231 25.8496 10.0312C25.8496 7.83937 24.0728 6.0625 21.8809 6.0625C19.689 6.0625 17.9121 7.83937 17.9121 10.0312C17.9121 12.2231 19.689 14 21.8809 14Z",
    fill: "url(#paint2_linear_715_14781)"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 13.2793,
    y: 14.2422,
    width: 6.16507,
    height: 1.52808,
    rx: 0.76404,
    transform: "rotate(45 13.2793 14.2422)",
    fill: "url(#paint3_linear_715_14781)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 13.2793,
    y: 14.2422,
    width: 6.16507,
    height: 1.52808,
    rx: 0.76404,
    transform: "rotate(45 13.2793 14.2422)",
    fill: "url(#paint4_radial_715_14781)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 13.2793,
    y: 14.2422,
    width: 6.16507,
    height: 1.52808,
    rx: 0.76404,
    transform: "rotate(45 13.2793 14.2422)",
    fill: "url(#paint5_linear_715_14781)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 14.3613,
    y: 13.1616,
    width: 6.16507,
    height: 1.52808,
    rx: 0.76404,
    transform: "rotate(45 14.3613 13.1616)",
    fill: "url(#paint6_linear_715_14781)"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 14.3613,
    y: 13.1616,
    width: 6.16507,
    height: 1.52808,
    rx: 0.76404,
    transform: "rotate(45 14.3613 13.1616)",
    fill: "url(#paint7_radial_715_14781)"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 14.3613,
    y: 13.1616,
    width: 6.16507,
    height: 1.52808,
    rx: 0.76404,
    transform: "rotate(45 14.3613 13.1616)",
    fill: "url(#paint8_linear_715_14781)"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_f_715_14781)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 22.309,
    cy: 9.60393,
    r: 6.30901,
    stroke: "url(#paint9_linear_715_14781)",
    strokeWidth: 1.25
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 22.309,
    cy: 9.60393,
    r: 6.30901,
    stroke: "url(#paint10_linear_715_14781)",
    strokeWidth: 1.25
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_715_14781",
    x: 6.11719,
    y: 21.2581,
    width: 8.63477,
    height: 8.75193,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -0.15
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.25
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.839216 0 0 0 0 0.592157 0 0 0 0 0.34902 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_715_14781"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_715_14781",
    x: 2.75391,
    y: 11.6719,
    width: 17.0488,
    height: 17.5492,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -0.5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.75
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.85098 0 0 0 0 0.541176 0 0 0 0 0.34902 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_715_14781"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_i_715_14781",
    x: 13.9121,
    y: 1.6625,
    width: 15.9375,
    height: 16.3375,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -0.4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.815686 0 0 0 0 0.505882 0 0 0 0 0.337255 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_715_14781"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_715_14781",
    x: 14.125,
    y: 1.41992,
    width: 16.3672,
    height: 16.368,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.625,
    result: "effect1_foregroundBlur_715_14781"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_715_14781",
    x1: 11.631,
    y1: 27.8751,
    x2: 9.63104,
    y2: 25.709,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4B954"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.907715,
    stopColor: "#ECA84F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_715_14781",
    x1: 8.03748,
    y1: 21.0313,
    x2: 11.2785,
    y2: 24.1875,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7C250"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8AB54"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_715_14781",
    x1: 21.8809,
    y1: 2.8125,
    x2: 21.8809,
    y2: 18,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8CF4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ED9953"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_715_14781",
    x1: 14.0858,
    y1: 15.1073,
    x2: 18.3285,
    y2: 15.1515,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6BF4E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EA994D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_715_14781",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(16.7422 14.6259) rotate(92.756) scale(0.327152 1.89502)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCBC66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCBC66",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_715_14781",
    x1: 16.6822,
    y1: 15.9802,
    x2: 16.6776,
    y2: 15.3219,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.186419,
    stopColor: "#E29226"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EC9B4F",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_715_14781",
    x1: 15.1679,
    y1: 14.0268,
    x2: 19.4105,
    y2: 14.071,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6BF4E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EA994D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_715_14781",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(17.8242 13.5453) rotate(92.756) scale(0.327152 1.89502)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB865"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBB865",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_715_14781",
    x1: 17.7643,
    y1: 14.8996,
    x2: 17.7596,
    y2: 14.2414,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.186419,
    stopColor: "#E29226"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E29226",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_715_14781",
    x1: 27.32,
    y1: 4.29815,
    x2: 21.4679,
    y2: 9.25853,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDD67"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFDD67",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_715_14781",
    x1: 17.6316,
    y1: 14.0001,
    x2: 19.0066,
    y2: 11.8126,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEB765"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEB765",
    stopOpacity: 0
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOldkey);
export default __webpack_public_path__ + "static/media/Old key.59dc6f079e37021a6abe9728c867c119.svg";
export { ForwardRef as ReactComponent };